export default {
  devices: 'APS-R Devices',
  device: 'APS-R Device',
  newDevice: 'New Device',
  addNewDevice: 'Add New Device',
  editDevice: 'Edit Device',
  deviceInfo: 'Device Information',
  searchDevices: 'Search devices...',
  customerId: 'Customer ID',
  customerIdPlaceholder: 'e.g., APS-001',
  customerIdHelp: 'Unique identifier from the sensor (customer_ID). Optional when a MAC address is given.',
  customerIdRequired: 'Customer ID is required',
  customerIdOrMacRequired: 'Enter a Customer ID or a MAC address',
  macAddress: 'MAC Address',
  macAddressPlaceholder: 'e.g., 00:0B:91:A4:09:BC',
  macAddressHelp:
    "Shown in the bus router's Clients list. Any format works. The sensor is matched on it when it first connects. Changing it on a sensor that is already reporting makes that sensor register as a new device.",
  macAddressInvalid: 'MAC address must have 12 hex digits, e.g. 00:0B:91:A4:09:BC',
  firmwareVersion: 'Firmware Version',
  ipAddress: 'IP Address',
  status: 'Status',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  statusMaintenance: 'Maintenance',
  lastSeen: 'Last Seen',
  vehicleAssignment: 'Vehicle Assignment',
  noVehicle: '-- No Vehicle --',
  noVehicleAssigned: 'No vehicle assigned to this device',
  currentOccupancy: 'Current Occupancy',
  currentPassengers: 'Current Passengers',
  attendanceSoFar: 'Total Boardings',
  deviceCreated: 'Device created successfully',
  deviceUpdated: 'Device updated successfully',
  deviceDeleted: 'Device deleted successfully',
  deleteConfirmation: 'Are you sure you want to delete this device?',
};
